import dayjs, { type Dayjs } from "dayjs";
import type { ITheftRecoveryFeature, ITheftRecoveryFeatureDto } from "./ITheftRecoveryFeature";
import { useUserSettings } from "@services/UserSettings";
import { DeviceInstallationStatus } from "@domain/General/DeviceInstallationStatus/DeviceInstallationStatus";

export class TheftRecoveryFeature implements ITheftRecoveryFeature
{

    title: string;
    type: string;
    status: DeviceInstallationStatus;
    utcDateInstalled?: string | Dayjs;
    isEnabledInAppSettings: boolean;
    isInstalled: boolean;

    constructor( model: ITheftRecoveryFeatureDto )
    {
        const settings = useUserSettings();
        this.status = model.status == DeviceInstallationStatus.Installed ? DeviceInstallationStatus.Installed : DeviceInstallationStatus.NotInstalled;
        this.title = model.title;
        this.type = model.type;
        this.utcDateInstalled = model.utcDateInstalled ? dayjs( model.utcDateInstalled ) : undefined;
        this.isInstalled = this.status == DeviceInstallationStatus.Installed;
        this.isEnabledInAppSettings = model.isEnabledInAppSettings;
    }

    /**
     * True if the feature is enabled
     */
    get isEnabled()
    {
        return this.isInstalled || this.isEnabledInAppSettings;
    }
    
}